export default __webpack_public_path__ + "static/media/ThankYou.8942adac.png";